const appid_ = '6452841273377139722';
const appsecret = 'C78oQyvzQdEKthwO';
import md5 from 'js-md5';
let base64 = require('js-base64').Base64;

function pass_token(obj) {
    var newObj = JSON.parse(JSON.stringify(obj));
    newObj['appid'] = appid_;
    var jsonSort_res = jsonSort(newObj) + '&app_secret=' + appsecret;
    var jsonSort_res_sc = md5(jsonSort_res).toUpperCase();
    newObj['sign'] = jsonSort_res_sc;
    var base64_encode = base64.encode(JSON.stringify(newObj));
    return base64_encode;
}

function jsonSort(jsonObj) {
    let arr = [];
    for (var key in jsonObj) {
        arr.push(key);
    }
    arr.sort();
    let str = '';
    for (var i in arr) {
        str += arr[i] + "=" + jsonObj[arr[i]] + "&";
    }
    return str.substr(0, str.length - 1);
}

export { pass_token };

// export default pass_token;
    // pass_token:pass_token
// };



// WEBPACK FOOTER //
// ./src/utils/request/util.js